import {Link} from 'react-router-dom';
import {ArrowRight} from 'lucide-react';
import {
  Button,
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from '@kroll-resolver-crisp/ui-components-react';
import {type ReportSummary} from '@/api/reporting';

// /reporting on its own: every report the user can see, as a card each. Choosing one opens it at its
// defaults; the dates are set on the report itself, so there is no "primary" report to pick here.
export function ReportsHome({reports}: {readonly reports: readonly ReportSummary[]}) {
  return (
    <div className="h-full w-full overflow-y-auto">
      <div className="mx-auto max-w-screen-2xl space-y-6 px-4 py-6">
        {/* The page header already titles this Reporting, so only the blurb is shown. */}
        <p className="text-muted-foreground max-w-[80ch] text-xs text-pretty">
          Pick a report to view it. Each opens on its default dates, which you can change there.
        </p>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(min(100%,440px),1fr))] gap-4">
          {reports.map((report) => (
            <Card key={report.id} className="flex flex-col">
              <CardHeader className="flex-1">
                <CardTitle className="font-heading text-base">{report.title}</CardTitle>
                {report.description ? (
                  <CardDescription className="text-pretty">{report.description}</CardDescription>
                ) : null}
              </CardHeader>
              <CardFooter className="border-border justify-end border-t">
                <Button size="sm" render={<Link to={`/reporting/${report.id}`} />}>
                  View Report
                  <ArrowRight />
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
